module.exports = __webpack_public_path__ + "img/5.2c5e5549.jpg";